import React, { useState } from 'react';
import { ChevronDown, Heart, Eye,Moon, Brain, Baby, Star, CheckCircle, Shield, Users, Award, Sparkles, Clock, Book, MessageCircle, Target, InfoIcon } from 'lucide-react';
import styles from './ThirdScreenServices.module.css';
import Button from '../../components/button/Button';

const ServiceBox = ({ title, children, icon: Icon, id }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.serviceWrapper} id={id}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`${styles.serviceButton} ${isOpen ? styles.active : ''}`}
        dir="rtl"
      >
        <div className={styles.titleContent}>
          <div className={styles.iconWrapper}>
            <Icon className={styles.icon} />
          </div>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <ChevronDown
          className={`${styles.chevron} ${isOpen ? styles.rotate : ''}`}
        />
      </button>
      
      <div className={`${styles.contentWrapper} ${isOpen ? styles.open : ''}`} dir="rtl">
        <div className={styles.content}>
          {children}
          <div className={styles.buttonContainer}>
            <Button 
              text="לפרטים נוספים" 
              message={`היי לריאן, אשמח לשמוע עוד על ${title}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <div className={styles.container} dir="rtl">
      <ServiceBox 
        title="הדרכת הורים בגישה האדלריאנית" 
        icon={Heart}
        id="הדרכת הורים"
      >
        <div className={styles.serviceContent}>
          <p className={styles.description}>
            ״כל ילד זקוק לבית והבית הוא הלב של ההורה״
            <br /><br />
            הדרכת הורים בגישה ההוליסטית אדלריאנית היא דרך מופלאה לתת לילד שלנו להרגיש שהלב שלנו הוא הבית הריגשי שלו המתהלך איתו בכל מקום ובכל זמן.
            המטרה הנעלה ביותר ביחסים שלנו עם הילדים שלנו היא לבסס מולם יחסים של אמון, אינטימיות ריגשית, יחסי קירבה, תקשורת מיטבית, הקשבה איכותית, כבוד הדדי, שיתוף פעולה ואמונה מלאה במקום שלהם בלב שלנו המהווים משמעות ועידוד להתפתחות ריגשית, קוגנטיבית, שפתית, תקשורתית ומוטורית שלהם.
          </p>
          
          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>מה מייחד את הגישה שלי?</h3>
            <ul className={styles.methodList}>
              <li>
                <Star className={styles.listIcon} />
                מעודדת את המהות בהורות, כל הורה זכה בפיקדון יקר הערך של הבריאה וזה הילד שלו. הוא מחזיק בידיו את הלב של הילד שלו והתפקיד ההורי הוא להרגיש את קצב פעימות הלב ולדעת לבחור ולנהוג נכון ממניעים נבונים ולא מתגובות אימפולסיביות.
              </li>
              <li>
                <Shield className={styles.listIcon} />
                מעודדת את הרצון העיקרי והאמיתי של ילדים להרגיש ביטחון ריגשי במקום שלהם בלב של ההורה, ככל שהוודאות במקום הריגשי גדולה יותר כך הסיכויים לגדל ילדים בריאים, קשובים ומשתפי פעולה היא גדולה יותר.
              </li>
              <li>
                <MessageCircle className={styles.listIcon} />
                 מערכת יחסים של הקשבה, אינטימיות ריגשית, כבוד הדדי, תקשורת מיטבית לצד גבולות ברורים, תוצאות הגיוניות התמודדות עם תיסכול ופתרון בעיות זו הדרך שמעניקה לילד חוויה מאוזנת ומייצרת אווירה משפחתית רגועה יותר.
              </li>
              <li>
                <Award className={styles.listIcon} />
                ההורה הוא המפתח לעידוד ושינוי התנהגותי אצל הילד – הגישה שלי לא מאמינה ב"לתקן" את הילד, אלא מתמקדת בתפקיד ההורי, התפקיד של ההורה הוא להבין שהתנהגות היא שפה ריגשית, ככל שהמודעות ההורית עולה ויש הבנה אמיתית למה הם הצרכים הרגשיים הפסיכולוגים של הילד הוא יוכל לתת מענה מותאם ובכך להיות הורה משפיע ומוביל.
              </li>
              <li>
                <Target className={styles.listIcon} />
                הענקת תחושת ערך, נראות, משמעות ושייכות לילד – התפקיד ההורי שלנו הוא לעלות את תחושת הערך של הילד שלנו בעיני עצמו, להעצים את הייחודיות שלו בתוך המשפחה, שאנחנו רואים אותו בפני עצמו ובכך לעודד את התרומה והמועילות שלו כפרט וככלל בקבוצה המשפחתית.
              </li>
              <li>
                <CheckCircle className={styles.listIcon} />
                גבולות, התמודדות עם תיסכול ופתרון בעיות - גבולות עבור הילדים שלנו מהווים ביטחון ריגשי, כגדר הפרדה ביניהם לבין החיים, הם מעניקים לילד שלנו את הביטחון בנו כהורים. תיסכול במידה הוא דבר מאוד בריא כי תיסכול מעודד בילדים שלנו את החשיבה היצירתית, את פיתרון הבעיות וגם את התוצאות ההגיוניות או הטבעיות של הבחירות שלהם.
              </li>
              <li>
                <Users className={styles.listIcon} />
                גישה מאוזנת בין הורה סמכותי לגישה דמוקרטית – איך להיות הורה סמכותי, מוביל המציב גבולות ברורים ואוכף אותם בדרך הנכונה, להורה שגם מעניק בחירה, אמפתי וקשוב.
              </li>
              <li>
                <Heart className={styles.listIcon} />
                אינטימיות ריגשית, שיתוף ושיתוף פעולה - אינטימיות ריגשית נבנת ככל שהילד מרגיש את הייחודיות שלו בלב של ההורה שלו, זה מעודד את הרצון שלו להיות קרוב יותר, לשתף יותר ולתת להורה מקום גדול יותר בלב ובעולם שלו.
              </li>
            </ul>
          </div>

          <p className={styles.description}>
            לעיתים כהורים אנחנו חשים שאין לנו כלים להתמודד בסיטואציות שונות ומאתגרות: הילד מסרב לשתף פעולה, הגבולות לא ברורים, תחושה של חוסר הקשבה ומאבק מתמשך ועוד. 
            או שכל מה שאנחנו רוצה זה ידע כדי להיות הורה טוב עבור הילד שלי - הדבר המשותף בין שני המצבים השונים האלה הוא הרצון למערכת יחסים מיטבית בינך לבין ילדך.
            <br /><br />
            הורות סמכותית בגישה דמוקרטית מצריכה איזון, כי לצד חופש הבחירה צריכים להיות גבולות ברורים ואיתנים, ולצד האמפתיה, ההקשבה וההכלה צריך להיות התמודדות עם תיסכול ופתרון בעיות.
            <br /><br />
            כדי לגדל ילדים בריאים, עם מודעות אישית, ריגשית, חוסן מנטלי וביטחון עצמי אנחנו צריכים להיות עבורם לעוגן, העוגן הוא ההבנה שמי שמוביל ומחזיק את החיים זה אני, ההורה, ולא הילד שלי. 
            <br /><br />
            הדרכת הורים בגישה הוליסטית אדלריאנית מתאימה גם להורים בראשית דרכם וגם להורים בוגרים, זו גישה שמטרתה לבנות מערכת יחסים מיטבית בין ההורה לילד ולבסס יחסים של אמון.
          </p>
        </div>
      </ServiceBox>

    

      <ServiceBox 
        title="ליווי התפתחותי לתינוקות ופעוטות" 
        icon={Brain}
        id="ליווי התפתחותי"
      >
        <div className={styles.serviceContent}>
          <p className={styles.description}>
            ליווי התפתחותי לתינוקות ופעוטות מגיל לידה ועד שלוש שנים בגישה ההוליסטית.
            גישה הרואה את הילד כשלם: גוף, נפש וסביבה וכיצד הקשר ביניהם משפיע על ההתפתחות של ילדך בכל האספקטים ההתפתחותיים.
            <br /><br />
            גישה זו מאמינה בכך שכל אספקט משפיע על האחר ומושפע מהאחר ושהקשר איתך, ההורה, הוא הבסיס העמוק ביותר לכל נקודות האור ההתפתחותיות.
            <br /><br />
            אני רואה בך כהורה שותף מלא ומשמעותי למימוש הפוטנציאל ההתפתחותי של ילדך – לא רק כמבצע הוראות, אלא כמי שמבין, משפיע, יוזם ויוצר בעולמו של ילדך.
          </p>
          
          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>מה מייחד את הגישה שלי?</h3>
            <ul className={styles.methodList}>
              <li>
                <Heart className={styles.listIcon} />
                אני מאמינה שכבר מרגע הלידה, הקשר בין ההורה לתינוק הוא הבסיס לתחושת ביטחון, שייכות וחוסן רגשי שנרקמים ונבנים בעולמו של התינוק.
              </li>
              <li>
                <Eye className={styles.listIcon} />
                כאשר ההורה מצליח לראות את ילדו דרך עיניים המבינות את צרכיו ההתפתחותיים והריגשיים כאחד, נוצר מרחב שבו הילד יכול להתפתח בביטחון, לגלות את עצמו (מוטורית, פיזית, ריגשית וקוגנטיבית) ולבנות תחושת מסוגלות פנימית.
              </li>
            </ul>
          </div>

          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>מה מיוחד בתהליכים שלי?</h3>
            <ul className={styles.methodList}>
              <li>
                <Star className={styles.listIcon} />
                בתהליך אני שמה דגש על כל האספקטים ההתפתחותיים: מוטורית, סנסורית, קוגנטיבית, שפתית, ריגשית, ותקשורתית המתחילים כבר מהימים הראשונים לחיים.
              </li>
              <li>
                <Award className={styles.listIcon} />
                התנועה הראשונית של התינוק והתייחסות של ההורה לאורך ההתפתחות משפיעים על התארגנות מערכת העצבים, על ויסות חושי, על תחושת שליטה בגוף, ואפילו על היכולת להרגיש בטוח בעולם.
              </li>
              <li>
                <Book className={styles.listIcon} />
                אני מנחה הורים כיצד לעודד תנועה איכותית ומאורגנת, כיצד לאפשר לילד לגלות את גופו ויכולותיו, וכיצד הורה קשוב, מתבונן, מכיל, מתווך, משקף, אמפתי ומבין ומשפיע על ההתפתחות של ילדו.
              </li>
            </ul>
          </div>

          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>למי התהליך מתאים?</h3>
            <ul className={styles.methodList}>
              <li>
                <Users className={styles.listIcon} />
                להורים שרוצים תהליך קבוצתי לקבלת ידע, לעידוד התפתחות וליצור חיבור עמוק בסדנאות ליווי התפתחותי המחולקות לפי סיגמטים התפתחותיים ושלבי התפתחות, קבוצות קטנות ואינטימיות לקבלת יחס אישי ומענה מותאם.
              </li>
              <li>
                <Target className={styles.listIcon} />
                להורים שרוצים תהליך פרטני לקבלת ידע, לעידוד התפתחות וליצור חיבור עמוק ועשיר יותר עם ילדיהם בתהליכי ליווי אישיים המותאמים באופן אישי לילד ולהורה.
              </li>
              <li>
                <Shield className={styles.listIcon} />
                להורים שילדיהם בעיכוב התפתחותי מאובחן ורוצים לקבל מענה, כלים וידע על מנת לעודד התפתחות מיטבית ואיכותית.
              </li>
            </ul>
          </div>

          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>מה חשוב שתדעו?</h3>
            <ul className={styles.methodList}>
              <li>
                <CheckCircle className={styles.listIcon} />
                הידע שלי הוא מקצועי ועדכני.
              </li>
              <li>
                <Sparkles className={styles.listIcon} />
                תהליכי ההתפתחות שאני מלווה מתייחסים לקשת הרחבה של האספקטים ההתהתפחותיים: סנסוטרי, מוטורי, קוגנטיבי, רגשי, תקשורתי, שפתי ומשחק.
              </li>
              <li>
                <Heart className={styles.listIcon} />
                אחת המטרות המרכזיות שלי בתהליכי ההתפתחות היא חיזוק הקשר בין ההורה לילד. בתפיסת העולם שלי יחסי קירבה, אינטימיות ריגשית, ביטחון ריגשית, יחסי אמון, הבנה, הכלה, הקשבה, יחס אישי ותקשורת מיטבית הם אלה המאפשרים התפתחות תקינה ואיכותית.
              </li>
              <li>
                <Star className={styles.listIcon} />
                אני משלבת בכל התהליכים שלי גם הדרכת הורים בגישה האדלריאנית כמטרה המעניקה בסיס לערכי יסוד במערכת היחסים שבין הורה לילד: שייכות, עידוד, הקשבה, כבוד, שיוויון ערך, שיח בגבוה העיניים, תיווך, שיקוף, אמפתיה ועוד כשפה שזורה ומוטמעת בתהליך הליווי.
              </li>
                   <li>
                <InfoIcon color='red' className={styles.listIcon} />
למידע נוסף על סדנאות בוטיק לתינוקות ו/או תהליכי ליווי פרטניים - היכנסו לדף הסדנאות שלי שנמצא בתפריט למעלה
              </li>
            </ul>
          </div>
        </div>
      </ServiceBox>
  <ServiceBox 
        title="ייעוץ וליווי תהליכי שינה" 
        icon={Moon}
        id="ייעוץ שינה"
      >
        <div className={styles.serviceContent}>
          <p className={styles.description}>
            ייעוץ וליווי תהליכי שינה בגישה ההוליסטית היא מכלול המשלב את שלבי ההתפתחות של הילד, מערכת היחסים בין ההורה לילד, מעגלי הסביבה ההתפתחותיים שלו ואת הצרכים הרגשיים-פסיכולוגים שלו.
            <br /><br />
            זו גישה הנותנת מענה לבכי, מכבדת את הקצב של הילד בתוך תהליך השינה ומעניקה לילד חוויה של יכולת ומסוגלות להירדמות עצמאית מתוך ביטחון וחוסן ריגשי.
            <br /><br />
            שינה היא אחת מנקודות המפתח להתפתחות תקינה ואיכותית, ותהליך נכון ומותאם אישית מאפשר כניסה לשינה איכותית מתוך תת מערכת במערכת העצבים המרכזית המכונה: ״המערכת הפרא-סימפתטית״.
          </p>
          
          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>מה הקשר בין שינה איכותית להתפתחות?</h3>
            <ul className={styles.methodList}>
              <li>
                <Moon className={styles.listIcon} />
                מלטונין הוא הורמון השינה האחראי על תחושת העייפות וויסות מחזורי השינה והעירות. הוא משפיע גם על הפרשת הורמון הגדילה.
              </li>
              <li>
                <Clock className={styles.listIcon} />
                הפרשת הורמון הגדילה מתבצעת בעיקר במהלך שלבי השינה העמוקה (NREM), במיוחד בשעות הראשונות של הלילה.
              </li>
              <li>
                <Sparkles className={styles.listIcon} />
                הורמון הגדילה הוא קריטי לתהליך ההתפתחות של הילד - תורם לצמיחה פיזית (עצמות, שרירים), להתפתחות מערכת החיסון ולהתחדשות רקמות.
              </li>
              <li>
                <Target className={styles.listIcon} />
                ביסוס מחזור שינה תקין מאפשר שחרור מרבי של הורמון הגדילה.
              </li>
              <li>
                <CheckCircle className={styles.listIcon} />
                הרדמות בשעה המותאמת לפי זיהוי סימני עייפות תומכת בסנכרון נכון של המלטונין.
              </li>
              <li>
                <Shield className={styles.listIcon} />
                שינה רציפה ולא מקוטעת עוזרת למחזורי שינה שלמים – כל מחזור תורם להתחדשות תאים, בניית רקמות ולמידה.
              </li>
            </ul>
          </div>

          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>איך עובדת המערכת הפרא-סימפתטית?</h3>
            <ul className={styles.methodList}>
              <li>
                <Brain className={styles.listIcon} />
                המערכת הפרא-סימפתטית היא חלק ממערכת העצבים האוטונומית, שאחראית על תהליכים בגוף שלא דורשים חשיבה מודעת.
              </li>
              <li>
                <Heart className={styles.listIcon} />
                תפקידה העיקרי להרגיע את הגוף ולהכניס אותו למצב של מנוחה, רוגע והתאוששות.
              </li>
              <li>
                <CheckCircle className={styles.listIcon} />
                כשהיא פעילה, קורים בגוף תהליכים כמו: ירידה בקצב הלב, הרפיית שרירים, נשימה עמוקה ואיטית יותר, עיכול משופר ומוכנות פיזיולוגית להירדמות ולשינה עמוקה.
              </li>
              <li>
                <Shield className={styles.listIcon} />
                היא "מתחרה" עם המערכת הסימפתטית שמובילה לשינה לא איכותית, שתפקידה להכין אותנו למצבי חירום ("הילחם או ברח").
              </li>
              <li>
                <Target className={styles.listIcon} />
                כשאין ויסות נכון או כשיש סטרס מתמשך – המערכת הסימפתטית יכולה להישאר פעילה גם כשהגוף זקוק לרגיעה, וזה יכול לגרום לקשיים בהירדמות ויקיצות מרובות בלילה.
              </li>
            </ul>
          </div>

          <p className={styles.description}>
            התהליך מתאים לכל הורה שרוצה לקבל ידע, לעשות שינוי בתהליכי השינה ולעודד הירדמות עצמאית ואיכותית.
            <br /><br />
            זיכרו כי הורות מודעת וגישה נכונה יכולים להעניק שיתוף פעולה וייצירת מרחב בטוח המאפשר הירדמות עצמאית ואיכותית.
          </p>
        </div>
      </ServiceBox>
      <ServiceBox 
        title="ייעוץ גמילה (חיתולים, מוצץ...)" 
        icon={Baby}
        id="ייעוץ גמילה"
      >
        <div className={styles.serviceContent}>
          <p className={styles.description}>
            גמילה מחיתולים, מוצצים וחפצי מעבר בגישה הוליסטית מותאמת אישית.
            <br /><br />
            גמילה מוצלחת היא הרבה יותר מ"לוותר על חיתול" או "להיפרד מהמוצץ וחפץ מעבר".
            היא תהליך רגשי, התפתחותי ואישי, זה הוא צעד משמעותי בדרך לעצמאות.
            <br /><br />
            הגישה ההוליסטית מתייחסת לשלב ההתפתחותי ולמוכנות האישית של הילד וההורה מתוך הקשבה וכבוד לקצב ולתהליך האישי של כל אחד מהם, התייחסות ראויה לסוג הגמילה, עידוד והעצמה של מערכת היחסים בין ההורה לילד ומתן חשיבות למעגלים בסביבה ההתפתחותית שלו.
          </p>
          
          <p className={styles.description}>
            אתם מרגישים שהגיע הזמן לגמול, אבל לא בטוחים איך להתחיל?
            <br />
            ניסיתם פעם והרגשתם שזה לא הלך כמו שציפיתם?
            <br />
            או אולי אתם רוצים להתכונן מראש לגמילה מותאמת, בטוחה ורגועה?
            <br />
            אני כאן בשבילכם.
          </p>
          
          <div className={styles.methodBox}>
            <h3 className={styles.methodTitle}>תהליך הגמילה משלב:</h3>
            <ul className={styles.methodList}>
              <li>
                <Target className={styles.listIcon} />
                תהליך ליווי מותאם אישית להורה ולילד
              </li>
              <li>
                <Heart className={styles.listIcon} />
                שילוב תכני הדרכת הורים אדלריאנית
              </li>
              <li>
                <Clock className={styles.listIcon} />
                זיהוי שלבי התפתחות והתייחסות אישית
              </li>
              <li>
                <Brain className={styles.listIcon} />
                בחינה עמוקה של צרכים רגשיים-פסיכולוגים ומתן מענה מותאם כהכנה לתהליך הגמילה ועידודו
              </li>
              <li>
                <Shield className={styles.listIcon} />
                מעבר בטוח ורגוע לעצמאות
              </li>
              <li>
                <Star className={styles.listIcon} />
                שיפור תחושת הביטחון והערך העצמי של הילד
              </li>
              <li>
                <Users className={styles.listIcon} />
                עידוד מערכת היחסים בין ההורה לילד
              </li>
              <li>
                <CheckCircle className={styles.listIcon} />
                בניית הרגלים בריאים לטווח ארוך
              </li>
            </ul>
          </div>

          <p className={styles.description}>
            גמילה היא לא רק מוכנות פיזיולוגית אלא גם מוכנות ריגשית, ולכן הגישה ההוליסטית מתייחסת לילד ולעולמו הפנימי כמכלול ונותנת מענה לכל היבט התפתחותי.
          </p>
        </div>
      </ServiceBox>
    </div>
  );
};

export default Services;